
		import PageState from "./state"
		import mutations from "./mutations"
		import {getModule} from '@/store/store'
		let APIS = {
      getSpeakerEmotionList: `get /apis/baohuo-yuanchuang/v1/speaker/getSpeakerEmotionList`, // 获取所有风格 含该风格的表情包
      getStyleList: `get /apis/baohuo-yuanchuang/video/style/page`,//获取视频风格
      getRatioList: `get /apis/baohuo-yuanchuang/video/ratio/list`,//获取所有比例
      getEffectList:`get /apis/baohuo-yuanchuang/video/effect/list`,//获取效果
	  submitCreate: (data) => {
		  return {
			  url: `/apis/baohuo-yuanchuang/oneClick/article/submit`,
			  method: 'post',
			  apiMonitor: {
				  resourceId: data.resourceId, // 资源id
				  resourceType: data.resourceType, // 资源类型
				  text: data.originContent, // 文案类型
			  }
		  }
	  }, // 提交视频制作
      getDefaultSpeaker:`get /apis/baohuo-yuanchuang/speaker/store/search`,//获取默认发音人-魔天轮
      sensitiveWordCheck:`post /apis/baohuo-yuanchuang/thirdPart/sensitive/check`, //检测敏感词
			// 获取生成次数权益
			queryMemberLeftRight:'get /apis/baohuo-account/v1/memberCenter/queryMemberLeftRight',
			articleDetail: `get /apis/baohuo-yuanchuang/oneClick/article/detail?_from=INNER`,
			getWordLimit: `get /apis/baohuo-yuanchuang/oneClick/article/wordLimit`,

			// 获取小说推文内容文本
			getNovelDetail: `get /apis/baohuo-yuanchuang/compose/resource/detail`,
			// 获取最近一文章信息
			getLastArticleInfo: 'get /apis/baohuo-yuanchuang/oneClick/article/getLastArticleInfo',
			// 获取用户信息
			getUserInfo: 'get /apis/baohuo-account/v1/user',
			
			// 智能文案
			generateSmartText: `post /apis/baohuo-yuanchuang/intelligent/tool/generate`,
			batchGenerateSmartText: `post /apis/baohuo-yuanchuang/intelligent/tool/batch/generate`,
			getSmartTextbyIds: `get /apis/baohuo-yuanchuang/intelligent/tool/record/status`,
			getSmartTextDetailbyIds: `/apis/baohuo-yuanchuang/intelligent/tool/record/detail`,
			getSmartTextList: `post /apis/baohuo-yuanchuang/intelligent/tool/record/list`,
			deleteSmartText: {
				custom: true,
				url: (data: any) => `/apis/baohuo-yuanchuang/intelligent/tool/record/delete/${data.recordId}`,
				method: 'delete',
			},
			// 抖音安全检测相关
			checkDouyinTextContent: `post /h5/tt/checkContent`,
			checkDouyinImgContent: `post /h5/tt/checkImage`,
			getDouyinAccessToken: `get /h5/tt/getAccessToken`,

			// 图生文
			understandImage: 'post /apis/baohuo-yuanchuang/image/understand', //图片理解
			generateStory: 'post /apis/baohuo-yuanchuang/image/story', //根据图片理解内容生成故事
			asyncGenerateStory: 'post /apis/baohuo-yuanchuang/image/story/async', // 异步生成图片故事
			getStoryResult: 'get /apis/baohuo-yuanchuang/image/story/result', // 获取异步生成图片故事结果

			// 获取讲真用户是否显示内容开关
			getSwitch: 'get /apis/baohuo-yuanchuang/intelligent/tool/querySwitch'
		}
		export default {
			...getModule({
				state:new PageState(),
				mutations,
				actions:{},
				APIS,
				name:"textToVideoPage"
			})
		}